<template>
	<div v-cloak>
		<h3>
            Detalle
            <span id="badge-detalles" class="badge badge-secondary">
                {{detalles.length}}
            </span>

            <div class="float-right">
            	<button 
            		type="button" 
            		class="btn btn-sm btn-primary" 
            		v-on:click="getDetalles"
            		v-tooltip="'Actualizar'">
					<i class="material-icons">refresh</i>
				</button>

            	<a 
		    	href="#" 
		    	class="btn btn-sm btn-success" 
		    	v-tooltip="labelAgregarProducto"  
		    	v-on:click.prevent="openModalDetalle"
		    	v-if="!disabledForm">
			        <i class="material-icons">add_shopping_cart</i> Agregar
			    </a>
            </div>
            <preloader v-if="detalles.length<=0 && loading"></preloader>
        </h3>

		<div class="table-responsive" v-if="detalles.length>0">
			<table class="table table-bordered table-striped table-sm">
	            <thead>
	                <tr>
	                    <th>
							Producto
	                    </th>
	                    <th width="50">Cantidad</th>
	                    <th>{{labelPrecio}}</th>
	                    <th>Sub Total</th>
	                    <th></th>
	                </tr>
	                <tr v-if="loading">
	                	<th colspan="5" class="p-0">
	                		<preloader></preloader>
	                	</th>
	                </tr>
	            </thead>
	            <tbody>
	            	<tr v-for="detalle in detalles">
	                    <td>
	                    	{{detalle.producto.DESCRIPCION_PRODUCTO}} 
	                    	- 
	                    	{{detalle.producto.grupo.DESCRIPCION_GRUPO}} 
	                    	- 
	                    	{{detalle.producto.subgrupo.DESCRIPCION_SUBGRUPO}}
	                    	
                    		<small class="font-weight-bold" v-if="detalle.SUMA==0">
                    			(No suma)
                    		</small>
	                    </td>
	                    <td class="text-right">
	                    	{{detalle.CANTIDAD}}
	                    </td>
	                    <td>
	                        <span class="float-right">
	                            {{money(detalle.PRECIO_PRODUCTO, true)}}
	                        </span>
	                    </td>
	                    <td>
	                        <span class="float-right">
	                        	{{money(detalle.TOTAL, true)}}
	                        </span>
	                    </td>

	                    <td class="text-center">
	                        <button 
	                        	:id="'productoDetalle'+detalle.CODIGO_DETALLE"
	                        	href="#" 
	                        	class="btn btn-table btn-sm" 
	                        	v-tooltip="'Editar producto'" 
	                        	v-on:click.prevent="editDetalle(detalle)"
	                        	v-if="!disabledForm">
	                            <i class="material-icons">edit</i>
	                        </button>
	                        <button 
	                        	:id="'productoDetalle'+detalle.CODIGO_DETALLE"
	                        	href="#" 
	                        	class="btn btn-table btn-sm" 
	                        	v-tooltip="'Eliminar producto'" 
	                        	v-on:click.prevent="deleteDetalle(detalle.CODIGO_DETALLE)"
	                        	v-if="!disabledForm">
	                            <i class="material-icons">delete</i>
	                        </button>
	                    </td>
	                </tr>
	            </tbody>
	            <tfoot>
	            	<tr>
	            		<th colspan="3" class="text-right">
	            			Total
	            		</th>
	            		<th class="text-right px-1">
	            			{{totalProductos}}
	            		</th>
	            		<td></td>
	            	</tr>
	            </tfoot>
	        </table>
	    </div>
	    <div v-if="detalles.length<=0 && !loading">
	    	<h5 class="text-muted text-center">
	    		No hay registros agregados.
	    	</h5>
	    	<empty icon="add_shopping_cart" title="Agrega Producto." description="Para poder visualizar el Detalle debes agregar un nuevo producto." v-if="false">
                <a 
                	href="#" 
                	v-on:click.prevent="openModalDetalle" 
                	class="btn btn-success" 
                	v-tooltip="labelAgregarProducto">
                    <i class="material-icons">add</i> {{labelAgregarProducto}}
                </a>
            </empty>
	    </div>

    	<div class="modal fade" id="modalDetalle" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static" v-if="!disabledForm">
		  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
		    <div class="modal-content">
		      	<div class="modal-header">
		        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='create'">
		        		{{labelAgregarProducto}}
		        	</h5>
		        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='edit'">
		        		Editar producto
		        	</h5>
		    	</div>
		    	<div class="modal-body">
		    		<div class="form-row">
		    			<div class="col-md-12 form-group">
		    				<label>
		    					Producto:
		    					<a href="#" v-on:click.prevent="loadProductos" v-if="!loadingProductos" class="font-weight-bold">
		    						<small>
		    							(Actualizar)
		    						</small>
		    					</a>
		    					<span v-else>
                        			<i class="fas fa-spinner fa-pulse"></i>
                    			</span>
		    				</label>
		    				<select2 v-model="form.producto" :disabled="loadingProductos">
				              <option v-for="producto in productos" v-bind:value="producto.CODIGO_PRODUCTO">
				              	{{producto.grupo.DESCRIPCION_GRUPO}}
				              	- 
				              	{{producto.subgrupo.DESCRIPCION_SUBGRUPO}} 
				              	- 
				              	{{producto.DESCRIPCION_PRODUCTO}} ({{producto.PRECIO}})
				              </option>
				            </select2>
				            <div v-if="errors && errors.producto" class="text-danger">
                                {{ errors.producto[0] }}
                            </div>
		    			</div>
		    			<div class="col-md-12 form-group">
		    				<label>
		    					Cantidad:
		    				</label>
		    				<input type="number" class="form-control" min="0" v-model="form.cantidad" step="any">
		    				<div v-if="errors && errors.cantidad" class="text-danger">
                                {{ errors.cantidad[0] }}
                            </div>
		    			</div>
		    			<div class="col-md-12 form-group">
		    				<label>
		    					{{labelPrecio}}:
		    				</label>
		    				<div class="input-group">
					        	<div class="input-group-prepend">
					             	<span 
					             		class="input-group-text" 
					             		id="basic-addon1">
					            		{{getMoney}}  	
					              	</span>
					        	</div>
					        	<input type="number" class="form-control" min="0" v-model="form.precio" step="any">
					        </div>
					        <div v-if="errors && errors.precio" class="text-danger">
                                {{ errors.precio[0] }}
                            </div>
		    			</div>
		    		</div>
	    			<div class="custom-control custom-checkbox">
						<input type="checkbox" class="custom-control-input" id="sumar" v-model="form.suma">
						<label class="custom-control-label" for="sumar">
							{{LabelSumarAlTotal}}
						</label>
					</div>

			      	<h3 class="text-right">
			        	<span>Total:</span>
			        	<span>{{total}}</span>
			        </h3>
		    	</div>
		    	<div class="modal-footer">
		    		<button 
		    			type="button" 
		    			class="btn btn-secondary" 
		    			v-on:click.prevent="validateAndCloseModalDetalle"
		    			:disabled="loadingCreate">
		    			Cancelar
		    		</button>
		        	<button 
		        		type="button"
		        		class="btn btn-primary" 
		        		v-on:click.prevent="storeDetalles"
		        		v-if="modal=='create'"
		        		:disabled="loadingCreate">
		        		Agregar
		        	</button>
		        	<button 
		        		type="button"
		        		class="btn btn-primary" 
		        		v-on:click.prevent="updateDetalle"
		        		v-if="modal=='edit'"
		        		:disabled="loadingCreate">
		        		Actualizar
		        	</button>
		    	</div>
		    </div>
		  </div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
            codigo: String,
            disabled: String
        },

		mounted(){
			if (this.codigo) {
				this.getDetalles();
			}
			this.loadProductos();
		},

		data(){
			return {
				modal: '',
				detalles: [],
				productos: [],
				loading: false,
				loadingProductos: false,
				loadingCreate: false,
				form: {
					codigo: '',
					producto: '',
					cantidad: 1,
					precio: 0,
					suma: true,
				},
				errors: {},
			}
		},

		methods: {
			getDetalles: function(){
				this.loading = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/detalles';

				axios.get(url)
				.then(response => {
					this.detalles = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			loadProductos(){
	            var url = '/productos';
	            this.loadingProductos = true;

	            axios.get(url).then(response => {
	                this.productos = response.data;
	            }).catch(error => {
	                console.log('error');
	            }).then(() => {
	            	this.loadingProductos = false;
	            });
	        },

			storeDetalles: function(){
				this.loadingCreate = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/detalles';
				this.errors = {};

				axios.post(url, {
					producto: this.form.producto,
					cantidad: this.form.cantidad,
					precio: this.form.precio,
					suma: this.form.suma
				})
				.then(response => {
					this.getDetalles();
					this.closeModalDetalle();
					this.suma = true;
					this.$toasted.show('El producto ha sido agregado.');
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show(`Error al ${this.labelAgregarProducto}.`);
				}).then(()=>{
					this.loadingCreate = false;
				});
			},

			editDetalle: function(data){
				this.form.codigo = data.CODIGO_DETALLE
				this.form.producto = data.CODIGO_PRODUCTO
				this.form.cantidad = data.CANTIDAD
				console.log(data.PRECIO_PRODUCTO)
				this.form.precio = data.PRECIO_PRODUCTO
				this.form.suma = data.SUMA == 1 ? true : false
				this.modal = 'edit';
				$('#modalDetalle').modal('show');
			},

			updateDetalle: function(){
				this.loadingCreate = true;
				var url = 'api/oportunidades/detalles/'+this.form.codigo;
				this.errors = {};

				axios.put(url, {
					codigo: this.form.codigo,
					producto: this.form.producto,
					cantidad: this.form.cantidad,
					precio: this.form.precio,
					suma: this.form.suma
				})
				.then(response => {
					this.getDetalles();
					this.closeModalDetalle();
					this.suma = true;
					this.form.codigo = '';
					this.$toasted.show('El producto ha sido actualizado.');
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar seguro.');
				}).then(()=>{
					this.loadingCreate = false;
				});
			},

			deleteDetalle: function(id){
	            var url = 'api/oportunidades/detalles/'+ id;
	            $('#productoDetalle'+id).attr('disabled', true);

	            axios.delete(url)
	            .then(response => {
	            	this.$toasted.show('Producto Eliminado');
	                this.getDetalles();
	            }).catch(error => {
	            	console.log(error.response);
	            	this.$toasted.show('Error al eliminar Producto');
	            }).then(()=>{
	            	$('#productoDetalle'+id).attr('disabled', false);
	            });
			},

			openModalDetalle: function(){
				this.modal = 'create'
				$('#modalDetalle').modal('show');
				this.cleanFields();
			},

			closeModalDetalle: function(){
				$('#modalDetalle').modal('hide');
				this.cleanFields();
			},

			validateAndCloseModalDetalle: function(){
				this.closeModalDetalle()
			},
			
			cleanFields: function(){
				this.form.producto = '';
				this.form.cantidad = 1;
				this.form.precio = 0;
				this.errors = {};
			},

			validaFields: function(){
				if (this.form.producto != null && this.form.producto != '') {
					return true;
				}

				if (this.form.cantidad != null && this.form.cantidad > 0) {
					return true;
				}

				if (this.form.precio != null && this.form.precio > 0) {
					return true;
				}

				return false;
			},
		},

		computed: {
            oportunidad: function () {
            	return this.codigo;
            },

            disabledForm: function(){
            	return this.disabled
            },

            total: function(){
            	return this.money(this.form.cantidad * this.form.precio, true);
            },

            totalProductos: function(){
				let total = [];
				var $module = this;
				var value = this.detalles.filter(x => x.SUMA != 0)

				Object.entries(value).forEach(([key, val]) => {
					total.push(val.TOTAL);
				});

				var tot = this.money(total.reduce(function(total, num){
					return parseFloat(total) + parseFloat(num);
				}, 0), true)

				$('#monto_solicitado').val(tot);
				return tot;
			},

			getMoney(){
				return crm.money
			},
			configuracion(){
				return this.configuracionBase() || {}
			},
			LabelSumarAlTotal(){
				return this.configuracion.OPORTUNIDADES_DETALLE_SUMAR_AL_TOTAL ?? 'Sumar al total'
			},
			labelAgregarProducto(){
				return this.configuracion.OPORTUNIDADES_DETALLE_AGREGAR_PRODUCTO ?? 'Agregar producto'
			},
			labelPrecio(){
				return this.configuracion.OPORTUNIDADES_DETALLE_PRECIO ?? 'Precio'
			}
        },

        watch: {
    		'form.producto': function (val, oldVal) {
      			if (this.modal == 'edit' && oldVal == '') {
      				return;
      			}

      			var $productos = this.productos.filter(function(value){
      				return value.CODIGO_PRODUCTO == val;
      			});


  				if ($productos.length > 0) {
      				this.form.precio = $productos[0].PRECIO ? $productos[0].PRECIO : 0;
      			}else{
      				this.form.precio = 0;
      			}
    		}
  		}
	}
</script>